export const DEFAULT_CARD_WIDTH = 190;
